import JoinUsPhase1View from '../body/main/JoinUsPhase1View';
import { modalType } from '../../util/ModalUtil';
import { ModalHeader } from '../../component/ModalRef';

import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';

const UserPrivateInfoModal = ({ type, modalRef, invisibleCheckbox }) => {
    const handleClose = () => {
        modalRef.current.close();
    };

    return (
        <>
            <ModalHeader title='개인정보수집동의' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner UserPrivateInfoModal'>
                    <JoinUsPhase1View type={type} modalRef={modalRef} invisibleCheckbox={invisibleCheckbox} />
                </div>
                <div className='modal-btn-wrap'>
                    <ConfirmButtonBox title='확인' onClick={(e) => handleClose()} />
                </div>
            </div>
        </>
    );
};

export default UserPrivateInfoModal;
